import { Box, Divider, Stack, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { useTranslate } from "src/locales";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzTitleAndInputBox from "src/components/core-components/ByzTitleAndInputBox/ByzTitleAndInputBox";
import ByzMuiRadioButton from "src/components/core-components/mui/buttons/ByzMuiRadioButton";
import ByzMuiButton from "src/components/core-components/mui/buttons/ByzMuiButton";
import ByzGrdEditButton from "src/components/core-components/mui/buttons-grid/ByzGrdEditButton";
import ByzGrdDeleteButton from "src/components/core-components/mui/buttons-grid/ByzGrdDeleteButton";
import ByzMuiDataGrid from "src/components/core-components/mui/data-grid";
import { GridColDef } from "@mui/x-data-grid-premium";
import { useState } from "react";
import AddIcon from '@mui/icons-material/Add';
import NewbornCareForm from "../../newborn-care/index";
import ByzMuiSnackBar from "src/components/core-components/mui/ByzMuiSnackBar";
import OpenComponentDialog from "src/components/shared-components/modal/openComponentModal";

function PageFour() {
  const { t } = useTranslate();
  const [alertOpen, setAlertOpen] = useState(false); 
  const [alertMessage, setAlertMessage] = useState(""); 

  const skinOptions = [
    { value: "1", label: "Sorun Yok" },
    { value: "2", label: "Soluk" },
    { value: "3", label: "Nemli" },
    { value: "4", label: "Kuru" },
    { value: "5", label: "Kızarık" },
    { value: "6", label: "Döküntü" },
    { value: "7", label: "Siyonize" },
    { value: "8", label: "Ekimoz" },
    { value: "9", label: "Peteşi" },
    { value: "10", label: "Mekonyumlu" },
    { value: "11", label: "Ödem" },
    { value: "12", label: "Kaşıntı" },
    { value: "13", label: "Diğer(Belirtiniz)" }
  ];
  /*
  const bloodTransfusionOptions = [
    { value: "1", label: "Evet" },
    { value: "2", label: "Hayır" },
    { value: "3", label: "Bilinmiyor" }
  ];
  */

  const physicianOptions = [
    { value: "1", label: "Dr. Ahmet Yılmaz" },
    { value: "2", label: "Dr. Mehmet Öz" },
    { value: "3", label: "Dr. Ayşe Kaya" }
  ];

  const faceExpressionOptions = [
    { value: "1", label: "Yüz ifadesi gevşek normal görünüm" },
    { value: "2", label: "Yüz kasları gergin, çene ve ağız buruşuk" }
  ];

  const calmingOptions = [
    { value: "1", label: "Sakin, ağlama yok" },
    { value: "2", label: "Hafif inleme, kesintili ağlama" },
    { value: "3", label: "Yüksek feryat, sürekli acı ve tiz ses, entübe ise sessiz ağlama" }
  ];

  const cryingOptions = [
    { value: "1", label: "Sakin" },
    { value: "2", label: "Değişken solunum: Düzensiz, hızlı, hırıltılı, nefes tutma" }
  ];

  const armsOptions = [
    { value: "1", label: "Gevşek, kas rijidesi yok, gerektiğinde hareketli" },
    { value: "2", label: "Yüz kasları gergin, çene ve ağız buruşuk" }
  ];

  const legsOptions = [
    { value: "1", label: "Gevşek, kas rijidesi yok, gerektiğinde hareketli" },
    { value: "2", label: "Yüz kasları gergin, çene ve ağız buruşuk" }
  ];

  const awarenessOptions = [
    { value: "1", label: "Uyku/uyanık sakin/sessiz uyuyor veya uyanık" },
    { value: "2", label: "Cırlak, uyanık, sakinleştirilemeyen" }
  ];

  const catheterOptions = [
    { value: "1", label: "Umbilikal Venöz" },
    { value: "2", label: "Umbilikal Arteriyel" },
    { value: "3", label: "Periferik Venöz" },
    { value: "4", label: "Santral Venöz" }
  ];

  const [painScore, setPainScore] = useState(0);
  const [faceExpression, setFaceExpression] = useState("");
  const [calming, setCalming] = useState("");
  const [crying, setCrying] = useState("");
  const [arms, setArms] = useState("");
  const [legs, setLegs] = useState("");
  const [awareness, setAwareness] = useState("");

  const calculatePainScore = () => {
    let score = 0;
    if (faceExpression === "2") score += 1;
    if (calming === "2") score += 1;
    if (calming === "3") score += 2;
    if (crying === "2") score += 1;
    if (arms === "2") score += 1;
    if (legs === "2") score += 1;
    if (awareness === "2") score += 1;
    setPainScore(score);
  };

  const [openCareForm, setOpenCareForm] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [isEditing, setIsEditing] = useState(false);
  const [careRecords, setCareRecords] = useState<any[]>([]);


  const handleOpenCareForm = (edit = false, rowData: any = null) => {
    if (edit && rowData) {
      setSelectedRow(rowData);
      setIsEditing(true);
    } else {
      setSelectedRow(null);
      setIsEditing(false);
    }
    setOpenCareForm(true);
  };

  const handleCloseCareForm = () => {
    setOpenCareForm(false);
  };

  const generateUniqueId = () => {
    return Date.now().toString(); 
  };

  const handleSaveCareForm = (formData?: any) => {
    if (isEditing) {
      setCareRecords(careRecords.map(record => 
        record.id === formData.id ? {...formData} : record
      ));
      setAlertMessage(t("newborn-patient-assessment.updated-success"));
    } else {
      setCareRecords([...careRecords, {...formData}]);
      setAlertMessage(t("newborn-patient-assessment.added-success"));
    }
    setOpenCareForm(false);
    setAlertOpen(true);
  };

  const handleConfirmDelete = (row: any) => {
    setSelectedRow(row);
    setConfirmDelete(true);
  };

  const handleDeleteRecord = () => {
    if (selectedRow) {
      setCareRecords(careRecords.filter(record => record.id !== selectedRow.id));
      setAlertMessage(t("newborn-patient-assessment.deleted-success"));
      setAlertOpen(true);
    }
    setConfirmDelete(false);
  };

  const careColumns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 90 }, 
    { field: 'date', headerName: 'Tarih', flex: 1 },
    { field: 'nurse', headerName: 'Hemşire', flex: 1 },
    { field: 'treatment', headerName: 'Tedavi', flex: 1 },
    { field: 'technique', headerName: 'Teknik', flex: 1 },
    { field: 'treatmentMethod', headerName: 'Tedavi Uygulama Yöntemi', flex: 1 },
    { field: 'specialCare', headerName: 'Özel Bakım', flex: 1 },
    { field: 'feeding', headerName: 'Beslenme', flex: 1 },
    { field: 'alert', headerName: 'Alet', flex: 1 },
    { field: 'pulse', headerName: 'Nabız', flex: 1 },
    { field: 'breathing', headerName: 'Solunum', flex: 1 },
    { field: 'temperature', headerName: 'Sıcaklık', flex: 1 },
    { field: 'urine', headerName: 'İdrar', flex: 1 },
    { field: 'stool', headerName: 'Gaita', flex: 1 },
    { field: 'weight', headerName: 'Kilo', flex: 1 },
    { field: 'hud02', headerName: 'HUD 02', flex: 1 },
    { field: 'meconium', headerName: 'Mekonyum', flex: 1 },
    { field: 'anomaly', headerName: 'Anomali', flex: 1 },
    { 
      field: 'actions',
      headerName: 'İşlemler',
      width: 120,
      renderCell: (params) => (
        <Stack direction="row" spacing={1}>
          <ByzGrdEditButton onClick={() => handleOpenCareForm(true, params.row)} />
          <ByzGrdDeleteButton onClick={() => handleConfirmDelete(params.row)} />
        </Stack>
      ),
    },
  ]; 

  return (
    <>
      <Box p={2}>
        <Grid container spacing={2} sx={{ padding: "0px" }}>
          <Box
            sx={{
              border: "1px solid #DBDBDB",
              borderRadius: "4px",
              padding: "20px",
              width: "100%",
            }}
          >
            <Grid
              sx={{
                backgroundColor: "#63B4FF33",
                color: "#2979C3",
                borderRadius: "10px",
              }}
            >
              <ByzMuiTypography isTitle paddingTop={"5px"}>
                {t("newborn-patient-assessment.physical-examination")}
              </ByzMuiTypography>
            </Grid>

            <Grid container spacing={2} pt={2}>
              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.skin")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={skinOptions}
                    label="label"
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    sx={{ pt: 1 }}
                    multiple = {false}
                  />

                  <ByzTitleAndInputBox marginLeft="0px" sx={{
                    marginTop: "8px", display: "flex", alignItems: "bottom",
                    justifyContent: "flex-end"
                  }}
                    title={t("description")}
                  >
                    <ByzMuiTextField
                      multiline={true}
                      rows={2}
                      sx={{
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={3} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.mongolian-spot")}
                >
                  <ByzMuiRadioButton
                    typographyText="yes,no,unknown"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />

                  <ByzTitleAndInputBox marginLeft="0px" sx={{
                    marginTop: "8px", display: "flex", alignItems: "bottom",
                    justifyContent: "flex-end"
                  }}
                    title={t("description")}
                  >
                    <ByzMuiTextField
                      multiline={true}
                      rows={2}
                      sx={{
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={3} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.birthmark")}
                >
                  <ByzMuiRadioButton
                    typographyText="yes,no,unknown"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />

                  <ByzTitleAndInputBox marginLeft="0px" sx={{
                    marginTop: "8px", display: "flex", alignItems: "bottom",
                    justifyContent: "flex-end"
                  }}
                    title={t("description")}
                  >
                    <ByzMuiTextField
                      multiline={true}
                      rows={2}
                      sx={{
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.head-neck")}
                >
                  <ByzMuiRadioButton
                    typographyText="newborn-patient-assessment.normal,newborn-patient-assessment.abnormal"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />
                  <ByzTitleAndInputBox marginLeft="0px" sx={{
                    marginTop: "8px", display: "flex", alignItems: "bottom",
                    justifyContent: "flex-end"
                  }}
                    title={t("description")}
                  >
                    <ByzMuiTextField
                      multiline={true}
                      rows={2}
                      sx={{
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.femoral-pulses")}
                >
                  <ByzMuiRadioButton
                    typographyText="newborn-patient-assessment.right,newborn-patient-assessment.left"
                    layout="row"
                    border="none"
                    fontSize={14} 
                  />
                  <ByzTitleAndInputBox marginLeft="0px" sx={{
                    marginTop: "8px", display: "flex", alignItems: "bottom",
                    justifyContent: "flex-end"
                  }}
                    title={t("description")}
                  >
                    <ByzMuiTextField
                      multiline={true}
                      rows={2}
                      sx={{
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </ByzTitleAndInputBox>
              </Grid>
            </Grid>

            <Divider
              sx={{
                borderColor: "black",
                borderBottomWidth: "2px",
                my: 2,
              }}
            />

            <Grid container spacing={2}>
            <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.extremity-hands")}
                >
                  <ByzMuiRadioButton
                    typographyText="newborn-patient-assessment.normal,newborn-patient-assessment.abnormal"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />
                  <ByzTitleAndInputBox marginLeft="0px" sx={{
                    marginTop: "8px", display: "flex", alignItems: "bottom",
                    justifyContent: "flex-end"
                  }}
                    title={t("description")}
                  >
                    <ByzMuiTextField
                      multiline={true}
                      rows={2}
                      sx={{
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.extremity-feet")}
                >
                  <ByzMuiRadioButton
                    typographyText="newborn-patient-assessment.normal,newborn-patient-assessment.abnormal"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />
                  <ByzTitleAndInputBox marginLeft="0px" sx={{
                    marginTop: "8px", display: "flex", alignItems: "bottom",
                    justifyContent: "flex-end"
                  }}
                    title={t("description")}
                  >
                    <ByzMuiTextField
                      multiline={true}
                      rows={2}
                      sx={{
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </ByzTitleAndInputBox>
              </Grid>
              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.respiratory-effort")}
                >
                  <ByzMuiRadioButton
                    typographyText="newborn-patient-assessment.normal,newborn-patient-assessment.abnormal"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />
                  <ByzTitleAndInputBox marginLeft="0px" sx={{
                    marginTop: "8px", display: "flex", alignItems: "bottom",
                    justifyContent: "flex-end"
                  }}
                    title={t("description")}
                  >
                    <ByzMuiTextField
                      multiline={true}
                      rows={2}
                      sx={{
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </ByzTitleAndInputBox>
              </Grid>
              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.feeding")}
                >
                  <ByzMuiRadioButton
                    typographyText="newborn-patient-assessment.breast-milk,newborn-patient-assessment.other"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />
                  <ByzTitleAndInputBox marginLeft="0px" sx={{
                    marginTop: "8px", display: "flex", alignItems: "bottom",
                    justifyContent: "flex-end"
                  }}
                    title={t("description")}
                  >
                    <ByzMuiTextField
                      multiline={true}
                      rows={2}
                      sx={{
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </ByzTitleAndInputBox>
              </Grid>
              <Grid md={3} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.newborn-circumcision")}
                >
                  <ByzMuiRadioButton
                    typographyText="newborn-patient-assessment.done,newborn-patient-assessment.not-done"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.performing-physician")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={physicianOptions}
                    label="label"
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    sx={{ pt: 1 }}
                    multiple = {false}
                  />
                </ByzTitleAndInputBox>
                </ByzTitleAndInputBox>
              </Grid>
            </Grid>

            <Divider
              sx={{
                borderColor: "black",
                borderBottomWidth: "2px",
                my: 2,
              }}
            />
            <Grid container spacing={2}>
            <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.cyanosis")}
                >
                  <ByzMuiRadioButton
                    typographyText="exists,not-exists"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />
                  <ByzTitleAndInputBox marginLeft="0px" sx={{
                    marginTop: "8px", display: "flex", alignItems: "bottom",
                    justifyContent: "flex-end"
                  }}
                    title={t("description")}
                  >
                    <ByzMuiTextField
                      multiline={true}
                      rows={2}
                      sx={{
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.umbilical-cord")}
                >
                  <ByzMuiRadioButton
                    typographyText="newborn-patient-assessment.normal,newborn-patient-assessment.abnormal"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />
                  <ByzTitleAndInputBox marginLeft="0px" sx={{
                    marginTop: "8px", display: "flex", alignItems: "bottom",
                    justifyContent: "flex-end"
                  }}
                    title={t("description")}
                  >
                    <ByzMuiTextField
                      multiline={true}
                      rows={2}
                      sx={{
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.posterior-fontanelle")}
                >
                  <ByzMuiRadioButton
                    typographyText="newborn-patient-assessment.normal,newborn-patient-assessment.abnormal"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />
                  <ByzTitleAndInputBox marginLeft="0px" sx={{
                    marginTop: "8px", display: "flex", alignItems: "bottom",
                    justifyContent: "flex-end"
                  }}
                    title={t("description")}
                  >
                    <ByzMuiTextField
                      multiline={true}
                      rows={2}
                      sx={{
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.anterior-fontanelle")}
                >
                  <ByzMuiRadioButton
                    typographyText="newborn-patient-assessment.normal,newborn-patient-assessment.abnormal"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />
                  <ByzTitleAndInputBox marginLeft="0px" sx={{
                    marginTop: "8px", display: "flex", alignItems: "bottom",
                    justifyContent: "flex-end"
                  }}
                    title={t("description")}
                  >
                    <ByzMuiTextField
                      multiline={true}
                      rows={2}
                      sx={{
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={3} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.urination")}
                >
                  <ByzMuiRadioButton
                    typographyText="yes,no,unknown"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />

                  <ByzTitleAndInputBox marginLeft="0px" sx={{
                    marginTop: "8px", display: "flex", alignItems: "bottom",
                    justifyContent: "flex-end"
                  }}
                    title={t("description")}
                  >
                    <ByzMuiTextField
                      multiline={true}
                      rows={2}
                      sx={{
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </ByzTitleAndInputBox>
              </Grid>
              </Grid>
              <Divider
                  sx={{
                    borderColor: "black",
                    borderBottomWidth: "2px",
                    my: 2,
                  }}
                />
              




            <Grid container spacing={2} pt={2}>
            <Grid md={3} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.defecation-meconium")}
                >
                  <ByzMuiRadioButton
                    typographyText="yes,no,unknown"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />

                  <ByzTitleAndInputBox marginLeft="0px" sx={{
                    marginTop: "8px", display: "flex", alignItems: "bottom",
                    justifyContent: "flex-end"
                  }}
                    title={t("description")}
                  >
                    <ByzMuiTextField
                      multiline={true}
                      rows={2}
                      sx={{
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </ByzTitleAndInputBox>
              </Grid>
            

              <Grid md={3} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.anus")}
                >
                  <ByzMuiRadioButton
                    typographyText="newborn-patient-assessment.open,newborn-patient-assessment.closed"
                    layout="row"
                    border="none"
                    fontSize={14}
                  />
                  <ByzTitleAndInputBox marginLeft="0px" sx={{
                    marginTop: "8px", display: "flex", alignItems: "bottom",
                    justifyContent: "flex-end"
                  }}
                    title={t("description")}
                  >
                    <ByzMuiTextField
                      multiline={true}
                      rows={2}
                      sx={{
                        pt: 1,
                      }}
                    />
                  </ByzTitleAndInputBox>
                </ByzTitleAndInputBox>
              </Grid>

              </Grid>

            

            <Grid container spacing={2} pt={2}>



            </Grid>

            <Divider
              sx={{
                borderColor: "black",
                borderBottomWidth: "2px",
                my: 2,
              }}
            />

            <Grid
              sx={{
                backgroundColor: "#63B4FF33",
                color: "#2979C3",
                borderRadius: "10px",
              }}
            >
              <ByzMuiTypography isTitle paddingTop={"5px"}>
                {t("newborn-patient-assessment.newborn-pain-scale")}
              </ByzMuiTypography>
            </Grid>

            <Grid container spacing={2} pt={2}>
              <Grid md={4} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.face-expression")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={faceExpressionOptions}
                    label="label"
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    sx={{ pt: 1 }}
                    onChange={(e: any) => setFaceExpression(e.target.value)}
                    multiple = {false}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={4} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.calming-method")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={calmingOptions}
                    label="label"
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    sx={{ pt: 1 }}
                    onChange={(e: any) => setCalming(e.target.value)}
                    multiple = {false}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={4} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.crying")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={cryingOptions}
                    label="label"
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    sx={{ pt: 1 }}
                    onChange={(e: any) => setCrying(e.target.value)}
                    multiple = {false}
                  />
                </ByzTitleAndInputBox>
              </Grid>
            </Grid>

            <Grid container spacing={2} pt={2}>
              <Grid md={4} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.arms")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={armsOptions}
                    label="label"
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    sx={{ pt: 1 }}
                    onChange={(e: any) => setArms(e.target.value)}
                    multiple = {false}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={4} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.legs")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={legsOptions}
                    label="label"
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    sx={{ pt: 1 }}
                    onChange={(e: any) => setLegs(e.target.value)}
                    multiple = {false}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={4} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.awareness-state")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={awarenessOptions}
                    label="label"
                    placeholder={t(
                      "open-process-menu.select"
                    )}
                    sx={{ pt: 1 }}
                    onChange={(e: any) => setAwareness(e.target.value)}
                    multiple = {false}
                  />
                </ByzTitleAndInputBox>
              </Grid>
            </Grid>

            <Grid container spacing={2} pt={2} alignItems="center">
              <Grid md={4} xs={6}>
                <ByzMuiButton
                  onClick={calculatePainScore}
                  sx={{
                    backgroundColor: "#63B4FF33",
                    color: "#2979C3",
                    border: "1px solid #2979C3",
                    mt: 2
                  }}
                >
                  {t("newborn-patient-assessment.calculate")}
                </ByzMuiButton>
              </Grid>

              <Grid md={8} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.result")}
                >
                  <ByzMuiTextField
                    value={painScore.toString()}
                    disabled
                    sx={{ pt: 1 }}
                  />
                </ByzTitleAndInputBox>
              </Grid>
            </Grid>

            <Divider
              sx={{
                borderColor: "black",
                borderBottomWidth: "2px",
                my: 2,
              }}
            />

            <Grid
              sx={{
                backgroundColor: "#63B4FF33",
                color: "#2979C3",
                borderRadius: "10px",
              }}
            >
              <ByzMuiTypography isTitle paddingTop={"5px"}>
                {t("newborn-patient-assessment.healthy-newborn-care-form")}
              </ByzMuiTypography>
            </Grid>

            <Box sx={{ display: 'flex', justifyContent: 'flex-start', mt: 2, mb: 2 }}>
              <ByzMuiButton
                onClick={() => handleOpenCareForm()}
                icon={<AddIcon />}
                sx={{
                  backgroundColor: "#63B4FF33",
                  color: "#2979C3",
                  border: "1px solid #2979C3",
                }}
              >
                {t("newborn-patient-assessment.add")}
              </ByzMuiButton>
            </Box>

            <Box sx={{ height: 400, width: "100%" }}>
              <ByzMuiDataGrid
                rows={careRecords}
                columns={careColumns}
                pageSize={5}
                getRowId={(row) => row.id}
              />
            </Box>
          </Box>

          <OpenComponentDialog
  title={t("newborn-patient-assessment.dialog.title")}
  open={openCareForm}
  onClose={handleCloseCareForm}
  isMedCard={true}
>
  <NewbornCareForm 
    onSave={handleSaveCareForm}
    initialData={selectedRow}
    isEditing={isEditing}
  />
</OpenComponentDialog>

          <Dialog
            open={confirmDelete}
            onClose={() => setConfirmDelete(false)}
          >
            <DialogTitle>{t("newborn-patient-assessment.confirm-delete")}</DialogTitle>
            <DialogContent>
              <DialogContentText>
                {t("newborn-patient-assessment.confirm-delete-message")}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <ByzMuiButton onClick={() => setConfirmDelete(false)}>
                {t("buttons.cancel")}
              </ByzMuiButton>
              <ByzMuiButton onClick={handleDeleteRecord} differentColor="red">
                {t("delete")}
              </ByzMuiButton>
            </DialogActions>
        </Dialog>

        <ByzMuiSnackBar
          open={alertOpen}
          onClose={() => setAlertOpen(false)}
          title={t("newborn-patient-assessment.operation-successful")}
          message={alertMessage || t("operation-successful-message")}
        />
        </Grid>
      </Box>
    </>
  );
}

export default PageFour;